import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const PermissionsContext = createContext(null);

export function PermissionsProvider({ children }) {
  const { user } = useAuth();
  const [permissoes, setPermissoes] = useState([]);
  const [carregando, setCarregando] = useState(true);

  const carregar = useCallback(async () => {
    if (!user) { setPermissoes([]); setCarregando(false); return; }
    if (user.role === 'supervisor') { setPermissoes([]); setCarregando(false); return; }
    try {
      const { data } = await api.get('/permissions');
      setPermissoes(data);
    } catch {
      setPermissoes([]);
    } finally {
      setCarregando(false);
    }
  }, [user]);

  useEffect(() => { carregar(); }, [carregar]);

  function can(modulo, acao = 'view') {
    if (!user) return false;
    if (user.role === 'supervisor') return true;
    const p = permissoes.find(x => x.role === user.role && x.modulo === modulo);
    if (!p) return false;
    if (acao === 'view') return p.canView;
    if (acao === 'edit') return p.canEdit;
    if (acao === 'sign') return p.canSign;
    return false;
  }

  return (
    <PermissionsContext.Provider value={{ permissoes, can, carregando, recarregar: carregar }}>
      {children}
    </PermissionsContext.Provider>
  );
}

export function usePermissions() {
  return useContext(PermissionsContext);
}
